<template>
  <div>
    <div class="search">
      <div class="left flex1">
        <el-form label-width="52px" :mode="queryControl" label-suffix=":">
          <div class="form-box">
            <el-form-item label="年份" class="formItem">
              <el-date-picker v-model="queryControl.year" :editable="false" :clearable="false" value-format="yyyy" placeholder="请选择年份" type="year" @change="query" />
            </el-form-item>
            <div>
              <el-button type="primary" @click="query">查询</el-button>
              <el-button @click="resetForm">重置</el-button>
              <el-button type="primary" @click="refresh">刷新</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="total_box mb22">
      <span>未对账总金额：<span class="active_color">￥{{ $formatCurrency(wait_all_price) || '0.00' }}</span></span>
    </div>
    <zf-table
      :columns="column"
      :data-source="tableData"
      :pagination="false"
    >
      <!-- 月份 -->
      <template
        slot="month"
        slot-scope="{ row }"
      >
        <span>{{ row.month }}</span>
      </template>
      <!-- 消耗金额 -->
      <template
        slot="work_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.work_price) }}
      </template>
      <!-- 支付宝金额 -->
      <template
        slot="zfb_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.zfb_price) }}
      </template>
      <!-- 微信金额 -->
      <template
        slot="wx_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.wx_price) }}
      </template>
      <!-- 服务费率 -->
      <template
        slot="rate"
        slot-scope="{ row }"
      >
        {{ row.rate }}%
      </template>
      <!-- 服务费 -->
      <template
        slot="service_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.service_price) }}
      </template>
      <!-- 待对账金额 -->
      <template
        slot="rcon_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.rcon_price) }}
      </template>
      <!-- 金额生产日期 -->
      <template
        slot="start_day"
        slot-scope="{ row }"
      >
        {{ row.start_day }} ~ {{ row.end_day }}
      </template>
      <!-- 操作 -->
      <template
        slot="action"
        slot-scope="{ row }"
      >
        <a v-if="powerReg('9eca38a4904451fe8d3531a39dff1ab2')" class="active_color" @click="sendInvoice(row)">发起对账单</a>
      </template>
    </zf-table>
    <!-- <noData v-else /> -->
    <el-dialog title="开票信息" width="800px" :visible.sync="infoVisible" center :before-close="(done) => {checked = false; done()}">
      <div v-if="!info.invoice_title" class="flex_center">暂无开票信息
        <a class="active_color ml20" @click="$router.push('/invoice/bill_info')">去添加</a>
      </div>
      <div v-else class="flex">
        <el-form :mode="info" label-width="120px" class="noMB flex1">
          <div class="bold mb22">发票信息<span class="active_color ml20 pointer" @click="$router.push('/invoice/bill_info')">去编辑</span></div>
          <el-form-item label="发票抬头:">{{ info.invoice_title }}</el-form-item>
          <el-form-item label="纳税人识别号:">{{ info.invoice_code }}</el-form-item>
          <el-form-item label="开户行及账号:">{{ info.bank }}</el-form-item>
          <!-- <el-form-item label="开户账号：">{{info.bank_card}}</el-form-item> -->
          <el-form-item label="地址、电话:">{{ info.company_address }}</el-form-item>
          <el-form-item label="开票内容:">{{ info.invoice_content }}</el-form-item>
        </el-form>
        <el-form :mode="info" label-width="120px" class="noMB flex1">
          <div class="bold mb22">收票信息<span class="active_color ml20 pointer" @click="$router.push('/invoice/bill_info')">去编辑</span></div>
          <el-form-item label="收件人:">{{ info.receive_person }}</el-form-item>
          <el-form-item label="手机号:">{{ info.receive_phone }}</el-form-item>
          <el-form-item label="收件地址:">{{ info.detail }}</el-form-item>
          <!-- <el-form-item label="详细地址：">{{info.address}}</el-form-item> -->
          <!-- <el-form-item label="邮编：">{{info.zip_code}}</el-form-item> -->
        </el-form>
      </div>
      <div v-if="info.invoice_title" slot="footer" class="dialog-footer">
        <el-checkbox v-model="checked">请确认开票信息无误</el-checkbox>
        <el-button class="ml30" type="primary" @click="infoSure">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="发起对账单" :visible.sync="settleVisible" width="400px" center>
      <el-dialog title="提醒" :visible.sync="uploadVisible" center width="400px" append-to-body>
        <div class="mb15 del">首次签署请上传"一般纳税人文件"。</div>
        <el-upload :class="{disUoloadSty: noneBtnImg}" action="#" :limit="1" :multiple="false" :auto-upload="true" :on-remove="handleRemove" :on-change="uploadChange" :before-upload="beforeUploadFile" :file-list="fileList" :http-request="uploadFile">
          <el-button size="small" type="primary"><i class="el-icon-upload2" />上传文件</el-button>
          <div slot="tip" class="el-upload__tip fs12 c9" style="line-height: 20px;">支持扩展名：.doc .docx .pdf .jpg .png .xls .xlsx，文件大小20MB以内</div>
        </el-upload>
        <div slot="footer" class="dialog-footer">
          <el-button @click="uploadVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitFn">确 定</el-button>
        </div>
      </el-dialog>
      <el-form ref="settleForm" :model="form" label-width="80px" size="small">
        <el-form-item label="开始日期" prop="start_day">
          <el-date-picker v-model="form.start_day" disabled type="date" style="width:270px;" placeholder="选择日期" :editable="false" :value-format="'yyyy-MM-dd'" />
        </el-form-item>
        <el-form-item label="结束日期" prop="end_day">
          <el-date-picker v-model="form.end_day" type="date" style="width:270px;" :picker-options="pickerOptionsCustom" placeholder="选择日期" :editable="false" :value-format="'yyyy-MM-dd'" @change="changeEnd" />
        </el-form-item>
        <el-form-item label="对账金额" style="margin-bottom:0;">{{ $formatCurrency(form.rcon_price) }}</el-form-item>
        <div style="padding-left:80px;">{{ tansf }}</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="settleVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="sure">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import column from '../columns/noAccountCheck'
// import noData from '@/components/noData'
import dayJs from 'dayjs'
import ZfTable from '@/components/ZfTable/CoreTable'
import { convertCurrency } from '@/utils/fn'
import { waitInvoice, sendInvoice, enddayRecon, getInvioceinfo, updatewaitRecon, uploadTaxpayer } from '@/api/invoice'
import { uploadNewFile } from '@/api/common'
export default {
  name: 'NoAccountCheck',
  components: {
    ZfTable
  },
  data() {
    const that = this
    return {
      column,
      queryControl: {
        year: dayJs().format('YYYY')
      },
      tableData: [],
      pageControl: {
        total: 0,
        pageSize: 10,
        page: 1
      },
      settleVisible: false,
      infoVisible: false,
      fileList: [],
      file_code: '',
      formRules: {
        contract_number: [
          { required: true, message: '请输入合同编号', trigger: 'blur' }
        ]
      },
      form: {
        recon_id: '',
        // contract_number: '',
        rcon_price: '',
        start_day: '',
        end_day: ''
      },
      uploadVisible: false,
      parseDate: {
        start_day: '',
        end_day: ''
      },
      info: {},
      checked: false, // 确认开票信息
      noneBtnImg: false,
      pickerOptionsCustom: {
        disabledDate(time) {
          const start_day = new Date(`${that.parseDate.start_day}`).getTime()
          const end_day = new Date(`${that.parseDate.end_day}`).getTime()
          const curTime = time.getTime()
          return curTime < start_day - 1 * 24 * 60 * 60 * 1000 || curTime > end_day
        }
      },
      wait_all_price: ''
    }
  },
  computed: {
    tansf() {
      var money = ''
      money = this.$formatCurrency(this.form.rcon_price)
      return convertCurrency(money)
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    async changeEnd(val) {
      const data = await enddayRecon({
        recon_id: this.form.recon_id,
        end_day: this.form.end_day
      })
      if (data.code === 200) {
        this.form.rcon_price = data.data.rcon_price
      }
    },
    resetForm() {
      this.queryControl = {
        year: dayJs().format('YYYY')
      }
      this.query()
    },
    async query() {
      const data = await waitInvoice({
        year: this.queryControl.year
      })
      if (data.code === 200) {
        this.tableData = data.data.list
        this.wait_all_price = data.data.wait_all_price
      }
    },
    async sendInvoice(row) {
      // 获取以前合同编号
      const data = await getInvioceinfo()
      if (data.code === 200) {
        this.form = { ...this.form, ...row }
        this.parseDate.start_day = row.start_day
        this.parseDate.end_day = row.end_day
        this.infoVisible = true
        this.info = {
          ...data.data.company_invoice,
          ...data.data.invoice_receive_address
        }
      }
    },
    sure() {
      this.$refs.settleForm.validate(async(valid) => {
        if (valid) {
          sendInvoice({
            recon_id: this.form.recon_id,
            end_day: this.form.end_day
          }).then(data => {
            if (data.code && data.code === 2001) {
              this.uploadVisible = true
            } else if (data.code === 200) {
              this.$message.success('发起成功')
              this.query()
              this.settleVisible = false
            }
          })
        }
      })
    },
    async infoSure() {
      if (!this.checked) {
        this.$message.error('请勾选确认开票信息无误!')
        return
      }
      this.infoVisible = false
      this.settleVisible = true
    },
    handleRemove(file, fileList) {
      this.noneBtnImg = fileList.length >= 1
      this.fileList = []
      this.file_code = ''
    },
    uploadChange(file, fileList) {
      this.noneBtnImg = fileList.length >= 1
    },
    beforeUploadFile(file) {
      const type = /^(.doc|.docx|.pdf|.jpg|.png|.xls|.xlsx)$/.test(file.name.slice(file.name.lastIndexOf('.')))
      const size = file.size / 1024 / 1024 < 20
      if (!type) {
        this.$message('文件格式错误,请重新选择')
      }
      if (!size) {
        this.$message('文件大小不可超过20MB')
      }
      return type && size
    },
    uploadFile(file) {
      const params = new FormData()
      params.append('file', file.file)
      this.noneBtnImg = true
      uploadNewFile(params).then(data => {
        if (data.code === 200) {
          this.fileList = [{ name: data.data.filename, url: data.data.fullpath, code: data.data.code }]
          this.file_code = data.data.code
        }
      })
    },
    async submitFn() {
      const data = await uploadTaxpayer({
        taxpayer: this.file_code
      })
      if (data.code === 200) {
        this.uploadVisible = false
        this.$message.success('上传成功')
      }
    },
    async refresh() {
      await updatewaitRecon()
      this.query()
      this.$message.success('刷新成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.ml30{
  margin-left: 30px;
}
</style>

